// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-loader',
    // #endregion
    // #region Props
    props: {
        size: {
            type: String,
            required: false,
            default: '50px'
        }
    },
    // #endregion
    // #region Computed
    computed: {
        loaderSize() {
            return {
                width: this.size,
                height: this.size
            };
        }
    },
    // #endregion
});
// #endregion
